export default defineNuxtRouteMiddleware((to) => {
  const user = useUserState()
  const loginReturnTo = useLoginReturnToMiddleware()

  if (user.value === null) {
    return loginReturnTo.navigateToLogin(to)
  }
})
